export default __webpack_public_path__ + "static/financial-freedom-a5bec2f533bf997eca6f240c458985cc.jpg";